import { create } from 'zustand';
import { mountStoreDevtool } from 'simple-zustand-devtools';
import { Query } from './types/QueryType';

interface GameQueryStore {
	gameQuery: Query;
	setSearchText: (search: string) => void;
	setGenreId: (genreId?: number) => void;
	setPlatformId: (platformId?: number) => void;
	setSortOrder: (sortOrder: string) => void;
	resetFilters: () => void;
}

const useGameStore = create<GameQueryStore>((set) => ({
	gameQuery: {},
	setSearchText: (search) => set(() => ({ gameQuery: { search } })),
	setGenreId: (genreId) =>
		set((store) => {
			const next = { ...store.gameQuery };
			if (genreId === undefined) delete next.genreId;
			else next.genreId = genreId;
			return { gameQuery: next };
		}),
	setPlatformId: (platformId) =>
		set((store) => {
			const next = { ...store.gameQuery };
			if (platformId === undefined) delete next.platformId;
			else next.platformId = platformId;
			return { gameQuery: next };
		}),
	setSortOrder: (sortOrder) =>
		set((store) => ({ gameQuery: { ...store.gameQuery, sortOrder } })),
	resetFilters: () => set({ gameQuery: {} }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('Game Store', useGameStore);
}
export default useGameStore;
